import { render, staticRenderFns } from "./OutrightsTable.vue?vue&type=template&id=62d4dc2a&"
import script from "./OutrightsTable.vue?vue&type=script&lang=js&"
export * from "./OutrightsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports